import { useMutation } from "@apollo/react-hooks";

import { TimeOff, UpdateTimeOffInput } from "@hubcapp/types";

import updateTimeOffMutation from "../graph-ql/updateTimeOff.graphql";

const useMutationUpdateTimeOff = () =>
  useMutation<{ updateTimeOff: TimeOff }, UpdateTimeOffInput>(
    updateTimeOffMutation,
  );

export default useMutationUpdateTimeOff;
